/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */

export class NbChatOptions {
  messageGoogleMapKey?: string;
}
